package org.zest.insan_360_website.data.page_states

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

data class ForgotPasswordState(
    val email: String = "",
    val isProcessing: Boolean = false,
    val isSent: Boolean = false
)

object ForgotPasswordPageState {
    var state by mutableStateOf(ForgotPasswordState())

    fun reset() {
        state = ForgotPasswordState()
    }
}
